import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SakuraDivider from "@/components/SakuraDivider";
import { Info } from "lucide-react";

const FAQS = [
  {
    q: "How far in advance should I order?",
    a: "At least 1–2 weeks in advance is recommended, especially for custom designs. Rush orders may be accepted depending on availability.",
  },
  {
    q: "Do you make custom themes?",
    a: "Yes! Colors, characters, party themes, and inspiration photos can be used to create a custom design tailored to your event.",
  },
  {
    q: "Do you require a deposit?",
    a: "It depends on the total. Orders under $30 require full payment at the time of booking. Orders over $30 require a 50% non-refundable deposit to secure your date, with the remaining balance due at pickup.",
  },
  {
    q: "Do you offer delivery?",
    a: "Local pickup is preferred. Delivery may be available depending on your location and order size — just ask on your inquiry.",
  },
  {
    q: "Do you ship?",
    a: "Shipping may be limited depending on the treat type, weather, and packaging needs. Reach out and I can let you know what's possible.",
  },
  {
    q: "Are treats made in a commercial kitchen?",
    a: "These products are homemade and produced in a cottage food operation that is not subject to Florida's food safety regulations.",
  },
];

export default function FAQ() {
  return (
    <div data-testid="page-faq">
      <section className="section">
        <div className="mx-auto max-w-5xl text-center">
          <span className="chip">FAQ</span>
          <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl text-sakura-ink">Sweet answers to your questions</h1>
          <SakuraDivider />
        </div>
      </section>

      <section className="section pt-0">
        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible className="card-soft p-2 md:p-4" data-testid="faq-accordion">
            {FAQS.map((f, idx) => (
              <AccordionItem key={f.q} value={`item-${idx}`} className="border-b last:border-b-0 border-sakura-200">
                <AccordionTrigger className="text-left px-4 md:px-6 py-5 font-serif text-lg text-sakura-ink hover:no-underline data-[state=open]:text-sakura-500" data-testid={`faq-trigger-${idx}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="px-4 md:px-6 pb-5 text-sakura-soft text-base leading-relaxed" data-testid={`faq-content-${idx}`}>
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-10 card-soft p-7 bg-sakura-100/50 border-sakura-300/60" data-testid="cottage-food-disclaimer">
            <div className="flex items-start gap-3">
              <Info className="h-5 w-5 text-sakura-500 mt-0.5 shrink-0" />
              <div>
                <h3 className="font-serif text-lg text-sakura-ink">Florida Cottage Food Disclaimer</h3>
                <p className="mt-1.5 text-sakura-soft text-sm leading-relaxed">
                  These products are homemade and produced in a cottage food operation that is not subject to Florida's food safety regulations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
